import { Store } from '@grafana/data';

const store = new Store();
export default store;
